import { useMemo } from 'react';
import { useVehicleValuations } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/useVehicleValuations.ts';
import { mapLoansToRows } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/LoansCard/investorLoans.utils.ts';
import { InvestorLoanRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/LoansCard/investorLoans.types.ts';

interface Result {
	rows: InvestorLoanRow[];
	isLoading: boolean;
	isError: boolean;
}

export const useVehicleLoans = ({ personId }: { personId: string }): Result => {
	const { valuations, isLoading, isError } = useVehicleValuations({ personId });

	const rows = useMemo(() => mapLoansToRows(valuations?.loans), [valuations]);

	return { rows, isLoading, isError };
};
